export default {
    functional: true,
    // @ts-ignore
    render: (h, { props }) => {
        return props.value || h(null)
    },
}
